/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { useGetAll } from 'utils/hooks/organizations';

export default function ParticipantTable({ participants }) {
  // #region Data
  const { t } = useTranslation();
  const { data: organizations } = useGetAll(t, {});

  const formatOrganization = (organizationId) => {
    const org = organizations?.find((o) => o.id === organizationId);
    return org ? org.name : '';
  };

  // #endregion Data
  return (
    <div className="form-table">
      <table className="mb-2">
        <thead>
          <tr>
            <th className="text-center" style={{ minWidth: 50, width: 50 }}>
              {t('formLayout.numericalOrder')}
            </th>
            <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
              {t('r09.form.email')}
            </th>
            <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
              {t('r09.form.fullName')}
            </th>
            <th className="text-center" style={{ minWidth: 160, width: '15%' }}>
              {t('r09.form.academicRank')}
            </th>
            <th className="text-center" style={{ minWidth: 160, width: '15%' }}>
              {t('r09.form.academicDegree')}
            </th>
            <th className="text-center" style={{ minWidth: 260, width: '25%' }}>
              {t('r09.form.organization')}
            </th>
          </tr>
        </thead>
        <tbody>
          {participants?.map((item, index) => (
            <tr key={item.id}>
              <td className="text-center">{index + 1}</td>
              <td>{item?.contact?.email}</td>
              <td>{item?.contact?.fullname}</td>
              <td>{t(`academicRank.${item?.academicRank}`)}</td>
              <td>{t(`academicDegree.${item?.academicDegree}`)}</td>
              <td>{formatOrganization(item?.organizationId)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

ParticipantTable.propTypes = {
  participants: PropTypes.arrayOf(PropTypes.object).isRequired,
};
